// extracted by mini-css-extract-plugin
export var dash = "TripleCol-module--dash---G+vh";
export var image = "TripleCol-module--image--xJjX5";
export var item = "TripleCol-module--item--1RX15";
export var label = "TripleCol-module--label--CcYrT";
export var text = "TripleCol-module--text--2PJeR";
export var texts = "TripleCol-module--texts--KjQMj";
export var wrapper = "TripleCol-module--wrapper--EH+b4";